import { calculatePolicyExpiryDate } from 'scenes/common/helpers/datetime';

export const marshalQuoteDates = (policyStartDate: string) => ({
  inception: policyStartDate,
  expiry: calculatePolicyExpiryDate(policyStartDate),
  effective: policyStartDate,
});
